module.exports = __webpack_public_path__ + "static/media/Spirulina.0ea4ec43.jpg";